import { ZipAvailabilityProbabilityEnum } from '@inter-ikea-kompis/enums';
import HomeDeliveryAvailabilityEnum from '../enums/HomeDeliveryAvailabilityEnum.js';
/**
 * Home delivery utility.
 */
export default class HomeDeliveryUtility {
    /**
     * Returns delivery availability status for all products.
     *
     * @param options Options.
     * @param options.zipAvailabilities Zip availabilities.
     * @param options.products Products for market availability.
     * @returns HomeDeliveryAvailabilityEnum.
     */
    static getAvailabilityStatus(options) {
        const { zipAvailabilities, products } = options;
        if (products && products.length > 0) {
            if (products.every((product) => product?.content?.priceInformation?.availableForHomeDelivery === false)) {
                return this.getUnavailableStatusProducts(products);
            }
        }
        if (!zipAvailabilities || !zipAvailabilities.length) {
            return null;
        }
        const isAllAvailable = zipAvailabilities.every((zipAvailability) => zipAvailability?.content?.availableForHomeDelivery);
        if (isAllAvailable) {
            return HomeDeliveryAvailabilityEnum.available;
        }
        const isSomeAvailable = zipAvailabilities.some((zipAvailability) => zipAvailability?.content?.availableForHomeDelivery);
        if (isSomeAvailable) {
            return HomeDeliveryAvailabilityEnum.mixed;
        }
        const hasAvailability = (messageType) => zipAvailabilities.every((zipAvailability) => !zipAvailability?.content?.availableForHomeDelivery &&
            zipAvailability.content.homeDelivery?.messageType === messageType);
        const { outOfStock, notSoldTemp, notInRange } = ZipAvailabilityProbabilityEnum;
        if (hasAvailability(outOfStock)) {
            return HomeDeliveryAvailabilityEnum.unavailable;
        }
        if (hasAvailability(notSoldTemp)) {
            return HomeDeliveryAvailabilityEnum.notSoldTemp;
        }
        if (hasAvailability(notInRange)) {
            return HomeDeliveryAvailabilityEnum.notInRange;
        }
        return null;
    }
    /**
     * Returns HomeDeliveryStatus of HomeDeliveryAvailabilityEnum type.
     *
     * @param products ...
     */
    static getUnavailableStatusProducts(products) {
        if (!products) {
            return null;
        }
        const { notSoldTemp, notInRange } = ZipAvailabilityProbabilityEnum;
        const isEveryMessageType = (messageType) => products.every((product) => product?.content?.priceInformation?.homeDelivery?.messageType === messageType);
        if (isEveryMessageType(notSoldTemp)) {
            return HomeDeliveryAvailabilityEnum.notSoldTemp;
        }
        if (isEveryMessageType(notInRange)) {
            return HomeDeliveryAvailabilityEnum.notInRange;
        }
        return HomeDeliveryAvailabilityEnum.unavailable;
    }
}
//# sourceMappingURL=HomeDeliveryUtility.js.map